import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShow:true,//侧边栏显示隐藏
  },
  getters: {
  },
  mutations: {
    OPENSHOW(state,step) {
      state.isShow = step;
    },
  },
  actions: {
    AsyicOPENSHOW(context, step) {
      context.commit('OPENSHOW',step)
    },
  },
  modules: {
  }
})
